import actions from './actions';

const initState = {
  hoverName: false,
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.HOVER_NAME:
      return {
        ...state,
        hoverName: !state.hoverName,
      };

    default:
      return state;
  }
}
